import { useState } from "react";
import { FolderPlus, Loader2Icon } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useCreateNoteVault } from "@/hooks/queries/useCreateNoteVault";

export function CreateVaultDialog({
  open,
  onOpenChange,
  onCreateVault,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onCreateVault: (name: string) => void;
}) {
  const [vaultName, setVaultName] = useState("");

  const createVault = useCreateNoteVault();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (vaultName.trim()) {
      onCreateVault(vaultName.trim());
      setVaultName("");
    }
  };

  const handleOpenChange = (newOpen: boolean) => {
    onOpenChange(newOpen);
    if (!newOpen) {
      setVaultName("");
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FolderPlus className="h-5 w-5" />
            <span>Create New Vault</span>
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="vault-name" className="text-sm font-medium">
              Vault Name
            </Label>
            <Input
              id="vault-name"
              value={vaultName}
              onChange={e => setVaultName(e.target.value)}
              placeholder="Enter vault name..."
              className="w-full"
              autoFocus
            />
          </div>
          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              onClick={() => handleOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!vaultName.trim() || createVault.isPending}
            >
              {createVault.isPending ? (
                <>
                  <Loader2Icon className="h-4 w-4 animate-spin" />
                  Creating...
                </>
              ) : (
                "Create Vault"
              )}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
